import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";


const CustomDataViewerGantt = ({ cell }) => {

    const ganttCell = cell.value === '' ? '' : 'gantt-cell';

    return (
      cell === undefined || cell === null ? <div/> :
      Object.keys(cell).includes('tooltip') && cell.tooltip !== '' && 
          cell.tooltip !== null && cell.tooltip !== undefined ? 
          <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-${cell.row}-${cell.column}`}>{cell.tooltip}</Tooltip>}>
                 <div className={ganttCell}></div>
          </OverlayTrigger> 
          : <div className={ganttCell}></div>
    );
};

export default CustomDataViewerGantt;